import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, keyframes } from "@mui/material/styles";
const strokeAnimation = keyframes `
  100% {
    stroke-dashoffset: 0;
  }
`;
const scaleAnimation = keyframes `
  0%, 100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
`;
const fillAnimation = keyframes `
  100% {
    box-shadow: inset 0px 0px 0px 30px var(--primary-brand-color);
  }
`;
const StyledSVG = styled("svg")(({ theme }) => ({
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    display: "block",
    margin: "0 auto",
    strokeWidth: 4,
    stroke: theme.palette.success.main,
    strokeMiterlimit: 10,
    boxShadow: `inset 0px 0px 0px ${theme.palette.success.main}`,
    animation: `${fillAnimation} 0.4s ease-in-out 0.4s forwards, ${scaleAnimation} 0.3s ease-in-out 0.9s both`,
    "& .success-checkmark__circle": {
        strokeDasharray: 166,
        strokeDashoffset: 166,
        strokeWidth: 4,
        strokeMiterlimit: 10,
        stroke: theme.palette.success.main,
        fill: "none",
        animation: `${strokeAnimation} 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards`,
    },
    "& .success-checkmark__check": {
        transformOrigin: "50% 50%",
        strokeDasharray: 48,
        strokeDashoffset: 48,
        strokeWidth: 4,
        animation: `${strokeAnimation} 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards`,
    },
}));
export const AnimatedSuccessCheckmark = () => (_jsxs(StyledSVG, Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 52 52" }, { children: [_jsx("circle", { className: "success-checkmark__circle", cx: "26", cy: "26", r: "25", fill: "none" }), _jsx("path", { className: "success-checkmark__check", fill: "none", d: "M14.1 27.2l7.1 7.2 16.7-16.8" })] })));
